export function setProgressWidth(instance, progress) {
  const { size, slidesPerView } = instance.details();

  if (progress == null) return;

  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  // const percentage = (100 / (size * slidesPerView));
  const percentage = (size / slidesPerView) * 100;
  progress.style.width = `${clamp(percentage, 0, 100)}%`;
}

/**
 * Update progressbar
 */

export function updateProgress(instance, progress, nav) {
  const { size, slidesPerView, relativeSlide } = instance.details();

  if (progress == null) return;

  const currentProgress = (((relativeSlide + slidesPerView) / size) * 100);
  const pixelWidth = (nav.offsetWidth / 100) * (100 - currentProgress);

  progress.style.transform = `translate(${-pixelWidth}px)`;
}
